<div class="materials-form-window" role="dialog" aria-modal="true" aria-labelledby="materials-form-title" topModalFocus (keydown.escape)="onModalClose()">
  <app-accessibility-header tabindex="0" [header]="'digitalDownload.header'"></app-accessibility-header>
    <div class="materials-form-header">
        <img class="myce-logo" src="assets/images/myce_logo_update.svg" alt="MyClassroom Economy logo">
        <c11n-icon-button
          class="header-close-btn"
          [size]="'small'"
          variant="ghost"
          [colorMode]="'on-dark'"
          labelText="{{ 'thankYouModal.close_btn_title' | translate }}"
          iconName="remove"
          (clickEvent)="onModalClose()">
        </c11n-icon-button>
    </div>
    <div class="materials-form-body">
        <form class="materials-form" [formGroup]="materialsForm" (ngSubmit)="onSubmit()" focusInvalidInput autocomplete="on">
          <div class="materials-form-scroll-content">
            
          <div class="materials-form-fields">

            <h1 id="materials-form-title" class="materials-form-title">
                {{ 'digitalDownload.header' | translate }}
            </h1>

            <div class="materials-form-description">
                {{ 'digitalDownload.description' | translate }}
            </div>

            <c11n-details
                expandLabelText="{{ 'informationRequest.header' | translate }}"
                collapseLabelText="{{ 'informationRequest.header' | translate }}"
                iconPosition="Trailing"
                labelAlign="left"
                labelWeight="normal"
                variant="primary"
                ariaLabelText="{{ 'informationRequest.header' | translate }}">
                <div class="data-collection-message" [innerHTML]="dataCollectionMessage"></div>
            </c11n-details>

            <div class="row form-row">
              <div class="col-sm-6">
                <div class="form-group">
                    <label 
                      for="formFieldFirstName" 
                      class="form-label inputLabel">
                      {{ 'formFields.firstName' | translate }} 
                      <span class="required-asterisk">*</span></label>
                    <c11n-input 
                      [size]="'medium'"
                      [hasError]="isSubmittedAndInvalid && (
                        materialsForm.controls['firstName'].hasError('required') || 
                        materialsForm.controls['firstName'].hasError('maxlength') ||
                        materialsForm.controls['firstName'].hasError('pattern'))">
                      <input 
                        c11nInput formControlName="firstName" 
                        type="text" 
                        class="form-control shadow-none"
                        id="formFieldFirstName"
                        [attr.aria-describedby]="'first-name-description'"
                        autocomplete="given-name"
                        attr.aria-label="{{ 'formFields.firstName' | translate }}" />
                    </c11n-input>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['firstName'].hasError('required')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['firstName'].hasError('required')"
                      [hintErrorId]="'first-name-description'" 
                      errorText="{{ 'formErrors.firstName.required' | translate }}"
                      [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['firstName'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['firstName'].hasError('maxlength')"
                      [hintErrorId]="'first-name-description'"
                      errorText="{{ 'formErrors.firstName.max' | translate }}"
                      [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                        materialsForm.controls['firstName'].hasError('pattern') &&
                        !(materialsForm.controls['firstName'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                        materialsForm.controls['firstName'].hasError('pattern') &&
                        !(materialsForm.controls['firstName'].hasError('maxlength'))"
                      [hintErrorId]="'first-name-description'"
                      errorText="{{ 'formErrors.firstName.specialCharacters' | translate }}"
                      [size]="'medium'">
                    </c11n-hint-error>
                </div>
              </div>
  
              <div class="col-sm-6">
                <div class="form-group">
                  <label 
                    for="formFieldLastName" 
                    class="form-label inputLabel">
                    {{ 'formFields.lastName' | translate }} 
                    <span class="required-asterisk">*</span>
                  </label>
                  <c11n-input 
                    [size]="'medium'"
                    [hasError]="isSubmittedAndInvalid && (
                      materialsForm.controls['lastName'].hasError('required') || 
                      materialsForm.controls['lastName'].hasError('maxlength') ||
                      materialsForm.controls['lastName'].hasError('pattern'))">
                    <input 
                      c11nInput formControlName="lastName" 
                      type="text" 
                      class="form-control shadow-none"
                      id="formFieldLastName"
                      autocomplete="family-name"
                      [attr.aria-describedby]="'last-name-description'"
                      attr.aria-label="{{ 'formFields.lastName' | translate }}" />
                  </c11n-input>
                  <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['lastName'].hasError('required')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['lastName'].hasError('required')"
                      [hintErrorId]="'last-name-description'" 
                      errorText="{{ 'formErrors.lastName.required' | translate }}"
                      [size]="'medium'">
                    </c11n-hint-error>
                  <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['lastName'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['lastName'].hasError('maxlength')"
                      [hintErrorId]="'last-name-description'"
                      errorText="{{ 'formErrors.lastName.max' | translate }}" 
                      [size]="'medium'">
                    </c11n-hint-error>
                  <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                      materialsForm.controls['lastName'].hasError('pattern') &&
                      !(materialsForm.controls['lastName'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                      materialsForm.controls['lastName'].getError('pattern') && 
                      !(materialsForm.controls['lastName'].hasError('maxlength'))"
                      [hintErrorId]="'last-name-description'"
                      errorText="{{ 'formErrors.lastName.specialCharacters' | translate }}" 
                      [size]="'medium'">
                    </c11n-hint-error>
                </div>
              </div>
            </div>

            <div class="row form-row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label 
                    for="formFieldEmail" 
                    class="form-label inputLabel">
                    {{ 'formFields.email' | translate }}
                    <span class="required-asterisk">*</span>
                  </label>
                  <c11n-input 
                    [size]="'medium'"
                    [hasError]="isSubmittedAndInvalid && (
                      materialsForm.controls['email'].getError('required') || 
                      materialsForm.controls['email'].getError('pattern') || 
                      materialsForm.controls['email'].hasError('maxlength'))">
                    <input 
                      c11nInput 
                      formControlName="email" 
                      type="email" 
                      autocomplete="email"
                      class="form-control shadow-none"
                      id="formFieldEmail"
                      [attr.aria-describedby]="'email-description'"
                      attr.aria-label="{{ 'formFields.email' | translate }}" />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      (materialsForm.controls['email'].getError('required') || materialsForm.controls['email'].getError('pattern'))"
                    *ngIf="isSubmittedAndInvalid && 
                      (materialsForm.controls['email'].getError('required') || materialsForm.controls['email'].getError('pattern'))"
                    [hintErrorId]="'email-description'"
                    errorText="{{ 'formErrors.email.invalid' | translate }}" 
                    [size]="'medium'">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      materialsForm.controls['email'].hasError('maxlength') &&
                      !(materialsForm.controls['email'].getError('required') || materialsForm.controls['email'].getError('pattern'))"
                    *ngIf="isSubmittedAndInvalid && 
                      materialsForm.controls['email'].hasError('maxlength') &&
                      !(materialsForm.controls['email'].getError('required') || materialsForm.controls['email'].getError('pattern'))"
                    [hintErrorId]="'email-description'"
                    errorText="{{ 'formErrors.email.max' | translate }}" 
                    [size]="'medium'">
                  </c11n-hint-error>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="formFieldGradeLevel" 
                    class="form-label inputLabel"
                    >{{ 'formFields.gradeLevel' | translate }} <span class="required-asterisk">*</span>
                  </label>
                  <c11n-dropdown
                    id="formFieldGradeLevel"
                    [size]="'medium'"
                    (stateChange)="getSelectedGrades($event)"
                    [direction]="'below'"
                    [selectedText]="this.selectedGrades"
                    [placeholderText]="''"
                    [hideLabel]="true"
                    [variant]="'multi-select basic'"
                    [activeItems]=""
                    [menuData]="gradeLevelList"
                    attr.aria-label="{{ 'formFields.gradeLevel' | translate }}"
                    [attr.aria-describedby]="'grade-level-description'" 
                    attr.aria-label="{{ 'formFields.gradeLevel' | translate }}"
                    [ngClass]="
                    { 
                      'dropdown-error': isSubmittedAndInvalid && materialsForm.controls['gradeLevel'].getError(
                        'required'
                      ), 
                      'dropdown-valid': !(isSubmittedAndInvalid && materialsForm.controls['gradeLevel'].getError(
                        'required'
                      ))
                    }">
                  </c11n-dropdown>
                  <c11n-hint-error
                    *ngIf="isSubmittedAndInvalid && materialsForm.controls['gradeLevel'].getError('required')"
                    [hasError]="isSubmittedAndInvalid && materialsForm.controls['gradeLevel'].getError(
                      'required'
                    )"
                    errorText="{{ 'formErrors.grade.required' | translate }}" [hintErrorId]="'grade-level-description'" 
                    [size]="'medium'"
                    [hintErrorId]="'grade-level-description'">
                  </c11n-hint-error>
                </div>
              </div>
            </div>

            <div class="row form-row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="formFieldSchoolCountryRegion" class="form-label inputLabel">{{ 'formFields.country'
                    | translate }}
                  </label>
                  <div class="input-width-small">
                    <c11n-select 
                      [size]="'medium'" 
                      [hideLabel]="true" 
                      [hintText]="''" 
                      (stateChange)="onSchoolAddressCountryChange($event)">
                      <select c11nSelectInput formControlName="schoolcountryregion" id="formFieldSchoolCountryRegion"
                        class="form-control c11n-select__box__select shadow-none"
                        [attr.aria-label]="'formFields.country' | translate">
                        <option *ngFor="let country of countries | keyvalue : preserveOriginalOrder" 
                          [value]="country.value">{{ 'countries.' + country.key | translate }}
                        </option>
                      </select>
                    </c11n-select>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="!enableAddSchoolMode && (materialsForm.value.schoolcountryregion !== this.countries.other)">
              <ng-container
                [ngTemplateOutlet]="selectedSchoolMetaData?.schoolMetaDataId ? selectedSchoolFromSearch : schoolSearchTemplate">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="enableAddSchoolMode">
              <div class="row form-row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="back-to-search mb-2 mt-1">
                      <a c11n-link [iconName]="'search'" [variant]="'primary-independent'" [iconPosition]="'leading'"
                        [fontWeight]="'bold'" href="javascript:void(0)" (click)="returnToSearch()">{{
                        'formFields.schoolSearch.return_to_school_search' | translate }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            
            <ng-container *ngIf="enableAddSchoolMode || (materialsForm.value.schoolcountryregion === this.countries.other)">
              <div class="row form-row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="formFieldSchoolName" class="form-label inputLabel">{{
                      'formFields.school' | translate
                      }}<span class="required-asterisk">*</span></label>
                    <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolName']?.errors">
                      <input c11nInput formControlName="schoolName" type="text" class="form-control shadow-none"
                        id="formFieldSchoolName" [attr.aria-describedby]="'schoolname-description'"
                        attr.aria-label="{{'formFields.school' | translate}}" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolName'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolName'].hasError('required')
                      " [hintErrorId]="'schoolname-description'" [errorText]="
                        'formErrors.school.required' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolName'].hasError('maxlength')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolName'].hasError('maxlength')
                      " [hintErrorId]="'schoolname-description'" [errorText]="
                        'formErrors.school.max' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolName'].getError('pattern') &&
                        !(materialsForm.controls['schoolName'].getError('maxlength'))" 
                      *ngIf="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolName'].getError('pattern') &&
                        !(materialsForm.controls['schoolName'].getError('maxlength'))" 
                      [hintErrorId]="'school-name-description'" 
                      errorText="{{ 'formErrors.school.specialCharacters' | translate }}" 
                      >
                    </c11n-hint-error>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="materialsForm.value.schoolcountryregion === this.countries.other">
              <div class="row form-row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form-label inputLabel" for="schoolAddressFullText">{{ 'formFields.schoolAddressFullText' | translate }} <span class="required-asterisk">*</span></label>
                    <c11n-textarea 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolAddressFullText']?.errors">
                        <textarea
                          c11nTextarea
                          formControlName="schoolAddressFullText" 
                          id="schoolAddressFullText"
                          name="schoolAddressFullText"
                          [attr.aria-describedby]="'school-address-full-text-description'"
                          [rows]="4"
                        ></textarea>
                    </c11n-textarea>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolAddressFullText'].hasError('required')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolAddressFullText'].hasError('required')"
                      [hintErrorId]="'school-address-full-text-description'" 
                      errorText="{{ 'formErrors.schoolAddressFullText.required' | translate }}"
                      >
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolAddressFullText'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolAddressFullText'].hasError('maxlength')"
                      [hintErrorId]="'school-address-full-text-description'"
                      errorText="{{ 'formErrors.schoolAddressFullText.max' | translate }}">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolAddressFullText'].hasError('pattern') &&
                        !(materialsForm.controls['schoolAddressFullText'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolAddressFullText'].hasError('pattern') &&
                        !(materialsForm.controls['schoolAddressFullText'].hasError('maxlength'))"
                      [hintErrorId]="'school-address-full-text-description'"
                      errorText="{{ 'formErrors.schoolAddressFullText.specialCharacters' | translate }}">
                    </c11n-hint-error>
                  </div>
                </div>
              </div>
            </ng-container>
            
            <ng-container *ngIf="enableAddSchoolMode">
              <div class="row form-row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label for="formFieldSchoolStreetAddress" class="form-label inputLabel">{{
                      'formFields.streetAddress' | translate
                      }}</label>
                    <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolstreetaddress']?.errors">
                      <input c11nInput formControlName="schoolstreetaddress" type="text" class="form-control shadow-none"
                        id="formFieldSchoolStreetAddress"
                        [attr.aria-describedby]="'schoolstreetaddress-description'"
                        [attr.aria-label]="'formFields.streetAddress' | translate" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolstreetaddress'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolstreetaddress'].hasError('required')
                      " [hintErrorId]="'schoolstreetaddress-description'" [errorText]="
                        'formErrors.streetAddress.required' | translate
                      " [size]="'medium'">
                      </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolstreetaddress'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolstreetaddress'].hasError('maxlength')"
                      [hintErrorId]="'schoolstreetaddress-description'"
                      errorText="{{ 'formErrors.streetAddress.max' | translate }}" >
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                      materialsForm.controls['schoolstreetaddress'].hasError('pattern') &&
                        !(materialsForm.controls['schoolstreetaddress'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                      materialsForm.controls['schoolstreetaddress'].hasError('pattern') &&
                        !(materialsForm.controls['schoolstreetaddress'].hasError('maxlength'))"
                        [hintErrorId]="'schoolstreetaddress-description'"
                      errorText="{{ 'formErrors.streetAddress.specialCharacters' | translate }}" >
                    </c11n-hint-error>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="schoolsecondaryaddressunit" class="form-label inputLabel">{{ 'formFields.secondaryAddressUnit' | translate }}</label>
                    <c11n-input 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolsecondaryaddressunit']?.errors">
                        <input
                          c11nInput
                          formControlName="schoolsecondaryaddressunit" 
                          id="schoolsecondaryaddressunit"
                          name="schoolsecondaryaddressunit"
                          [attr.aria-describedby]="'schoolsecondaryaddressunit-description'"
                        />
                    </c11n-input>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength')"
                      [hintErrorId]="'schoolsecondaryaddressunit-description'"
                      errorText="{{ 'formErrors.secondaryAddressUnit.max' | translate }}" >
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolsecondaryaddressunit'].hasError('pattern') &&
                        !(materialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolsecondaryaddressunit'].hasError('pattern') &&
                        !(materialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength'))"
                      [hintErrorId]="'schoolsecondaryaddressunit-description'"
                      errorText="{{ 'formErrors.secondaryAddressUnit.specialCharacters' | translate }}" >
                    </c11n-hint-error>
                  </div>
                </div>
              </div>
    
              <div class="row form-row">
                <div class="col-12 col-md-9 schoolcity-input">
                  <div class="form-group">
                    <label for="formFieldSchoolCity" class="form-label inputLabel">{{
                      'formFields.city' | translate
                      }}</label>
                    <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolcity']?.errors">
                      <input c11nInput formControlName="schoolcity" type="text" class="form-control shadow-none"
                        id="formFieldSchoolCity" [attr.aria-describedby]="'schoolcity-description'"
                        [attr.aria-label]="'formFields.city' | translate" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolcity'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolcity'].hasError('required')
                      " [hintErrorId]="'schoolcity-description'" [errorText]="
                        'formErrors.city.required' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolcity'].hasError('maxlength')"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolcity'].hasError('maxlength')"
                      [hintErrorId]="'schoolcity-description'"
                      errorText="{{ 'formErrors.city.max' | translate }}">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolcity'].hasError('pattern') &&
                        !(materialsForm.controls['schoolcity'].hasError('maxlength'))"
                      *ngIf="isSubmittedAndInvalid && 
                        materialsForm.controls['schoolcity'].hasError('pattern') &&
                        !(materialsForm.controls['schoolcity'].hasError('maxlength'))"
                      [hintErrorId]="'schoolcity-description'"
                      errorText="{{ 'formErrors.city.specialCharacters' | translate }}">
                    </c11n-hint-error>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div *ngIf="materialsForm.value.schoolcountryregion === countries.unitedStates" class="form-group">
                    <label for="formFieldSchoolState" class="form-label inputLabel">{{
                      'formFields.state' | translate
                      }}</label>
                    <c11n-input 
                      [size]="'medium'" 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolstate']?.errors">
                      <input 
                        c11nInput 
                        formControlName="schoolstate" 
                        type="text" 
                        maxlength="2"
                        (input)="
                          materialsForm
                            .get('schoolstate')
                            ?.setValue($any($event.target).value?.toUpperCase())
                        "
                        autocapitalize="characters"
                        class="form-control shadow-none"
                        id="formFieldSchoolState"
                        [attr.aria-describedby]="'schoolstate-description'"
                        [attr.aria-label]="'formFields.state' | translate" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolstate'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolstate'].hasError('required')
                      " [hintErrorId]="'schoolstate-description'" [errorText]="
                        'formErrors.state.required' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolstate'].hasError('isIn') && !(materialsForm.controls['schoolstate'].hasError('required'))"
                      *ngIf="isSubmittedAndInvalid && materialsForm.controls['schoolstate'].hasError('isIn') && !(materialsForm.controls['schoolstate'].hasError('required'))"
                      [hintErrorId]="'schoolstate-description'"
                      errorText="{{ 'formErrors.state.invalid' | translate }}">
                    </c11n-hint-error>
                  </div>
                  <div *ngIf="materialsForm.value.schoolcountryregion === countries.canada" class="form-group">
                    <label for="formFieldSchoolState" class="form-label inputLabel">{{
                      'formFields.province' | translate
                    }}</label>
                    <c11n-select
                      [hintText]="''"
                      errorText="{{ 'formErrors.province.required' | translate }}"
                      [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolstate']?.errors"
                      [hideLabel]="true"
                    >
                      <select c11nSelectInput id="formFieldSchoolState" required formControlName="schoolstate">
                        <option value="" data-option="placeholder" disabled selected>{{ 'formFields.select' | translate }}</option>
                        <option *ngFor="let province of provinces" [value]="province.canadianProvinceCode">{{ province.name }}</option>
                      </select>
                    </c11n-select>
                  </div>
                </div>
              </div>
    
              <div class="row form-row">
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label for="formFieldSchoolZipCode" class="form-label inputLabel">{{ 'formFields.schoolSearch.schoolZipCode' | translate
                    }}</label>
                    <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && materialsForm.controls['schoolZipCode']?.errors">
                      <input c11nInput formControlName="schoolZipCode" type="text" class="form-control shadow-none"
                        id="formFieldSchoolZipCode" [attr.aria-describedby]="'schoolzipcode-description'"
                        [attr.aria-label]="'formFields.schoolSearch.schoolZipCode' | translate" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolZipCode'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolZipCode'].hasError('required')
                      " [hintErrorId]="'schoolzipcode-description'" [errorText]="
                        'formErrors.zipCode.required' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error [hasError]=" 
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolZipCode'].hasError('inValidZip')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        materialsForm.controls['schoolZipCode'].hasError('inValidZip')
                      " [hintErrorId]="'schoolzipcode-description'" [errorText]="
                        'formErrors.zipCode.invalid' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="row form-row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label class="form-label inputLabel" for="formFieldReference">
                    {{ 'formFields.reference' | translate }} 
                    <span class="required-asterisk">*</span>
                  </label>
                  <c11n-select
                    [hideLabel]="true"
                    [hintText]="''"
                    [hasError]="isSubmittedAndInvalid && materialsForm.controls['reference'].errors"
                    [hasHintErrorAlertRole]="true"
                    errorText="{{ 'formErrors.reference.required' | translate }}"
                    attr.aria-label="{{ 'formFields.reference' | translate }}">
                    <select c11nSelectInput required 
                      id="formFieldReference" 
                      name="formFieldReference" 
                      formControlName="reference">
                      <option value="" data-option="placeholder" disabled selected>
                        {{ 'formFields.select' | translate }}
                      </option>
                      <option [attr.aria-label]="reference.value"
                        *ngFor="let reference of references | keyvalue: preserveOriginalOrder" [ngValue]="reference.key">
                        {{ reference.value }}
                      </option>
                    </select>
                  </c11n-select>
                </div>
              </div>
            </div>

            <div class="checkbox-group">
              <div class="row form-row--checkbox">
                <div class="form-group--checkbox">
                  <c11n-checkbox 
                    [labelText]="('formFields.terms.termsLink' | translate) + ' ' + ('formFields.terms.termsLink' | translate)"
                    hideLabel="true">
                    <input 
                        c11nCheckboxInput formControlName="isTermsAndConditionsAccepted" 
                        id="formFieldTerms" 
                        type="checkbox"
                        attr.aria-label="{{ 'formFields.terms.aria-label' | translate }}"
                        [attr.aria-describedby]="'terms-and-conditions-description'"/>
                  </c11n-checkbox>
                  <div class="form-label--checkbox"
                    >{{ 'formFields.terms.agree' | translate }}&nbsp;
                    <a c11n-link 
                      [routerLink]="signupExternalLinks.terms_conditions_url | langLink"
                      target="_blank" attr.aria-label="{{ 'formFields.terms.termsLinkAriaLabel' | translate }}"
                      >{{ 'formFields.terms.termsLink' | translate }}</a>&nbsp;<span class="required-asterisk">*</span>
                  </div>
                </div>
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && materialsForm.controls['isTermsAndConditionsAccepted'].getError(
                    'required'
                  )"
                  errorText="{{ 'formErrors.terms.required' | translate }}"
                  [size]="'medium'"
                  [hintErrorId]="'terms-and-conditions-description'">
                </c11n-hint-error>
              </div>

              <div class="row form-row--checkbox">
                <div class="form-group--checkbox">
                  <c11n-checkbox 
                    [labelText]="('formFields.privacyPolicy.agree' | translate) + ' ' + ('formFields.privacyPolicy.privacyPolicyLink' | translate)"
                    hideLabel="true">
                    <input 
                        c11nCheckboxInput formControlName="isPrivacyPolicyAccepted" 
                        id="formFieldPrivacyPolicy" 
                        type="checkbox"
                        attr.aria-label="{{ 'formFields.privacyPolicy.aria-label' | translate }}"
                        [attr.aria-describedby]="'privacy-policy-description'"/>
                  </c11n-checkbox>
                  <div class="form-label--checkbox"
                    >{{ 'formFields.privacyPolicy.agree' | translate }}&nbsp;
                    <a c11n-link 
                      [routerLink]="signupExternalLinks.privacy_policy_url | langLink"
                      target="_blank" attr.aria-label="{{ 'formFields.privacyPolicy.privacyPolicyLinkAriaLabel' | translate }}" 
                      >{{ 'formFields.privacyPolicy.privacyPolicyLink' | translate }}</a>&nbsp;<span class="required-asterisk">*</span>
                  </div>
                </div>
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && materialsForm.controls['isPrivacyPolicyAccepted'].getError(
                    'required'
                  )"
                  errorText="{{ 'formErrors.privacyPolicy.required' | translate }}"
                  [size]="'medium'"
                  [hintErrorId]="'privacy-policy-description'">
                </c11n-hint-error>
              </div>
            </div>
          </div>

          <div class="remember-response-message">
              {{ 'digitalDownload.remember_response' | translate }}
          </div>
          <div class="required-message">
              <span class="required-asterisk">*</span> {{ 'formFields.required' | translate }}
          </div>

          <re-captcha
            formControlName="captchaResponse"
            siteKey="6LdApAYqAAAAAOQW_aWW2F_vYOZZU36XKu2dWfaU"
            class="center-captcha">
          </re-captcha>
          <c11n-hint-error
            [hasError]="isSubmittedAndInvalid && materialsForm.controls['captchaResponse'].getError('required')"
            *ngIf="isSubmittedAndInvalid && materialsForm.controls['captchaResponse'].getError('required')"
            [hintErrorId]="'captchaResponse-description'"
            errorText="{{ 'formErrors.reCaptcha.required' | translate }}" 
            [size]="'medium'">
          </c11n-hint-error>

          </div>
          <div class="button-group">
              <c11n-button
                  class="submit-button"
                  labelText="{{ 'digitalDownload.download_button' | translate }}"
                  buttonType="submit"
                  size="medium"
                  [isWaiting]="isSaving"
                  attr.aria-label="{{ 'digitalDownload.download_button' | translate }}"
                  [attr.aria-describedby]="'submit-description'">
              </c11n-button>
              <c11n-button
                  class="cancel-button"
                  labelText="{{ 'digitalDownload.cancel_button' | translate }}"
                  buttonType="button"
                  variant="secondary"
                  size="medium"
                  attr.aria-label="{{ 'digitalDownload.cancel_button' | translate }}"
                  [attr.aria-describedby]="'cancel-description'"
                  (clickEvent)="navigateAway()">
              </c11n-button>
          </div>
        </form>
    </div>
</div>

<!-- School Search constellation component-->

<ng-template #schoolSearchTemplate>
  <div class="row form-row">
    <div class="col-12">
      <div class="form-group">
        <div role="search"
        class="c11n-search c11n-search--medium c11n-search--below c11n-search--attached c11n-search--on-light">
          <label for="myce_search_school" class="form-label inputLabel">{{ 'formFields.schoolSearch.search_label' | translate }}</label>
          <c11n-search #searchComponent [id]="'myce_search_school'" [hideLabel]="true"
            [hasMenu]="false" (stateChange)="onSearchAction($event)"
            [attr.aria-describedby]="'schoolsearch-description'"></c11n-search>
          <c11n-hint-error [hasError]="
            isSubmittedAndInvalid && !triggeredSchoolSearch &&
            materialsForm.controls['schoolMetaDataId'].hasError('required')
            " *ngIf="
              isSubmittedAndInvalid && !triggeredSchoolSearch &&
              materialsForm.controls['schoolMetaDataId'].hasError('required')
            " [hintErrorId]="'schoolsearch-description'" [errorText]="
              'formErrors.school.required' | translate
            " [size]="'medium'">
          </c11n-hint-error>

          <div *ngIf="triggeredSchoolSearch" class="c11n-menu c11n-search__menu" role="menu" id="search-menu">
            <div class="c11n-menu__menu c11n-search__menu__menu">
              <div class="c11n-menu__group" role="group">
                <button *ngFor="let school of schools; trackBy: trackBySchoolId" [attr.aria-label]="school.name"
                  type="button" class="c11n-menu__item c11n-search__menu__item" role="menuitem"
                  (click)="onSchoolSelect(school)">
                  <span class="c11n-search__menu__item_label">
                    {{ school.schoolName }}
                  </span>
                </button>
              </div>

              <div class="c11n-search__menu__summary">
                <div class="c11n-search__menu__summary__heading" [ngSwitch]="schools.length">
                  <ng-container *ngSwitchCase="0">{{ 'formFields.schoolSearch.noResults' | translate }}</ng-container>
                  <ng-container *ngSwitchCase="1">{{ 'formFields.schoolSearch.oneResult' | translate }}</ng-container>
                  <ng-container *ngSwitchDefault>{{ 'formFields.schoolSearch.multipleResults' | translate:{ dynamicText: schools.length } }}</ng-container>
                </div>
                <button type="button" class="c11n-menu__item c11n-search__menu__item c11n-search__menu__summary__see-all"
                  role="menuitem" (click)="onManualAdd()">
                  <span class="c11n-search__menu__item__label">
                    <span class="c11n-menu__item-label">{{ 'formFields.schoolSearch.addSchoolManually' | translate }}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #selectedSchoolFromSearch>
  <div class="row form-row">
    <div class="col-12">
      <div class="selected-school-container">
        <div class="back-to-search">
          <a c11n-link [iconName]="'search'" [variant]="'primary-independent'" [iconPosition]="'leading'"
            [fontWeight]="'bold'" href="javascript:void(0)" (click)="onSearchNewSchool()">{{ 'formFields.schoolSearch.newSearch' | translate }}</a>
        </div>
        <div class="selected-school">
          <div class="selected-school__name">
            <div class="selected-school__name__text">
              {{ 'formFields.schoolSearch.schoolName' | translate }}
            </div>
            <div class="selected-school__name__value">
              {{selectedSchoolMetaData.schoolName}}
            </div>
          </div>
          <div class="selected-school__zip">
            <div class="selected-school__zip__text">
              {{ 'formFields.schoolSearch.schoolZipCode' | translate }}
            </div>
            <div class="selected-school__zip__value">
              {{selectedSchoolMetaData.zipCode}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
